'use strict'

// const mockMode = process.env.MOCKMODE

export function projectFilesService (instance) {
	const http = instance.http

	const service = {
		/**
		 * @param formData
		 */
		upload: function (formData) {
			// No .catch() here -- a failed request must stay rejected so the
			// caller can tell success from failure (see E24-11; this used to
			// swallow the rejection and resolve either way).
			return http.post(
				'/project-upload',
				formData,
				{ headers: { 'Content-Type': 'multipart/form-data' } }
			).then(function (resp) {
				let out = resp.result
				return out
			})
		}
	}

	return service
}



// WEBPACK FOOTER //
// /var/tomcat/.jenkins/workspace/EasyTitle24/easytitle24-2.x-common/services/project-files-service.js